import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { arrayOf, bool, func, number, oneOfType, shape, string } from 'prop-types';
import difference from 'lodash/difference';
import isEqual from 'lodash/isEqual';
import omit from 'lodash/omit';
import without from 'lodash/without';
import defined from 'defined';
import { OPTION_PROP_TYPES, OPTGROUP_PROP_TYPES } from './prop-types';

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
/** makes sure value is a wrapped array, empty if nil */


var ensureArray = function ensureArray(value) {
  if (Array.isArray(value)) {
    return value;
  } // empty string, null or undefined shouldn't be wrapped


  if (value === '' || value == null) {
    return [];
  }

  return [value];
};

var isDifferent = function isDifferent(a, b, isArrays) {
  return isArrays ? !!difference(a, ensureArray(b)).length : !isEqual(a, b);
};
/** allows a single propType or an array of any of them */


var oneOrMoreOf = function oneOrMoreOf() {
  for (var _len = arguments.length, propTypes = new Array(_len), _key = 0; _key < _len; _key++) {
    propTypes[_key] = arguments[_key];
  }

  return oneOfType([].concat(propTypes, [arrayOf(oneOfType(propTypes))]));
};

var withOptions = function withOptions(ComponentToAddOptions) {
  var propTypes = {
    options: arrayOf(oneOfType([shape(OPTION_PROP_TYPES), shape(OPTGROUP_PROP_TYPES)])).isRequired,
    defaultValue: oneOrMoreOf(string, number),
    multiple: bool,
    onChange: func,
    value: oneOrMoreOf(string, number)
  };
  var defaultProps = {
    defaultValue: '',
    multiple: false,
    onChange: function onChange() {},
    options: [],
    value: ''
  };

  var WithOptions =
  /*#__PURE__*/
  function (_Component) {
    _inherits(WithOptions, _Component);

    function WithOptions(props) {
      var _this;

      _classCallCheck(this, WithOptions);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(WithOptions).call(this, props));
      _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
      var defaultValue = props.defaultValue,
          value = props.value,
          multiple = props.multiple; // handle value state internally since it can be single or an array
      // and we have to build that with the differences between
      // checkbox, radio, and select

      var startingValue = defined(value, defaultValue);
      _this.state = {
        value: multiple ? ensureArray(startingValue) : startingValue
      };
      return _this;
    }
    /** allow component to be controlled by outer components */


    _createClass(WithOptions, [{
      key: "componentWillUpdate",
      value: function componentWillUpdate(nextProps) {
        var state = this.state.value;
        var multiple = this.props.multiple;
        var next = nextProps.value;
        var changed = // handles when state is []
        isDifferent(next, state, multiple) || // handles when next is []
        isDifferent(state, next, multiple);

        if (changed) {
          // eslint-disable-next-line react/no-will-update-set-state
          this.setState({
            value: next
          });
        }
      }
      /**
       * handles onChange for checkboxes, radios, select and select[multiple],
       * keeping consistent track of multiple selections as an array
       */

    }, {
      key: "handleChange",
      value: function handleChange(e) {
        var _this$props = this.props,
            onChange = _this$props.onChange,
            multiple = _this$props.multiple;
        var _e$target = e.target,
            value = _e$target.value,
            options = _e$target.options,
            checked = _e$target.checked;
        var current = this.state.value;
        var next;

        if (options) {
          // dealing with select
          // select[multiple] only returns the first selection for `.value`,
          // so we need to rebuild each time
          next = multiple ? _toConsumableArray(options).filter(function (o) {
            return o.selected;
          }).map(function (o) {
            return o.value;
          }) : value;
        } else if (checked === true) {
          // dealing with checked radio/checkbox
          // add to current state
          next = multiple ? current.concat(value) : value;
        } else if (checked === false) {
          // dealing with unchecked radio/checkbox
          // remove from current state
          next = multiple ? without(current, value) : value;
        } else {
          // unhandlable input
          next = current;
        } // update and notify parent with added value data,
        // but keep state in case component isn't controlled


        this.setState({
          value: next
        });
        onChange(e, {
          value: next
        });
      }
    }, {
      key: "render",
      value: function render() {
        var value = this.state.value; // we don't include defaultValue herein
        // Component will be controlled but will emit onChange as if it
        // were uncontrolled

        return React.createElement(ComponentToAddOptions, _extends({}, omit(this.props, ['defaultValue']), {
          value: value,
          onChange: this.handleChange
        }));
      }
    }]);

    return WithOptions;
  }(Component);

  WithOptions.displayName = "WithOptions(".concat(getDisplayName(ComponentToAddOptions), ")");
  WithOptions.propTypes = _objectSpread({}, ComponentToAddOptions.propTypes, propTypes);
  WithOptions.defaultProps = _objectSpread({}, ComponentToAddOptions.defaultProps, defaultProps);
  return WithOptions;
};

export default withOptions;